module.exports = __webpack_public_path__ + "img/assurEuleuk.1622094a.png";